var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * Dashboard_2Filled component
 */
export class BlocksIconDashboard2Filled extends BlocksElement {
    constructor() {
        super(...arguments);
        /**
         *
         * Append to the class name to pass classes (such as utility classes) into the internals
         */
        this.styleModifier = '';
    }
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span class="${componentClassName}" role="presentation">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <g clip-path="url(#clip0_21774_63)">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M3.42885 0.857178H20.5717C21.9918 0.857178 23.1431 2.00844 23.1431 3.42861V20.5715C23.1431 21.9916 21.9918 23.1429 20.5717 23.1429H3.42885C2.00868 23.1429 0.857422 21.9916 0.857422 20.5715V3.42861C0.857422 2.00844 2.00868 0.857178 3.42885 0.857178ZM6.00028 4.92861C5.40854 4.92861 4.92885 5.4083 4.92885 6.00003C4.92885 6.59177 5.40854 7.07146 6.00028 7.07146H9.42885C10.0206 7.07146 10.5003 6.59177 10.5003 6.00003C10.5003 5.4083 10.0206 4.92861 9.42885 4.92861H6.00028ZM6.00028 8.78575C5.40854 8.78575 4.92885 9.26544 4.92885 9.85718C4.92885 10.4489 5.40854 10.9286 6.00028 10.9286H12.0003C12.592 10.9286 13.0717 10.4489 13.0717 9.85718C13.0717 9.26544 12.592 8.78575 12.0003 8.78575H6.00028ZM18.6231 11.1282C19.1046 11.4721 19.216 12.1413 18.8722 12.6228L14.5864 18.6228C14.4154 18.8623 14.1534 19.0209 13.8619 19.0613C13.5704 19.1018 13.2751 19.0205 13.0453 18.8366L9.50836 16.0072L6.75789 18.7576C6.33947 19.176 5.66109 19.176 5.24267 18.7576C4.82424 18.3393 4.82424 17.6608 5.24267 17.2425L8.67124 13.8139C9.05728 13.4278 9.67185 13.3938 10.0982 13.7348L13.5004 16.4566L17.1284 11.3773C17.4723 10.8958 18.1415 10.7842 18.6231 11.1282Z"
            />
          </g>
          <defs>
            <clipPath id="clip0_21774_63">
              <rect width="24" height="24" fill="white" />
            </clipPath>
          </defs>
        </svg>
      </span>
    `;
    }
}
__decorate([
    property()
], BlocksIconDashboard2Filled.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconDashboard2Filled.prototype, "iconTitle", void 0);
__decorate([
    property()
], BlocksIconDashboard2Filled.prototype, "size", void 0);
__decorate([
    property()
], BlocksIconDashboard2Filled.prototype, "styleModifier", void 0);
if (customElements.get('cat-icon-dashboard2-filled') === undefined) {
    customElements.define('cat-icon-dashboard2-filled', BlocksIconDashboard2Filled);
}
